(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cavador-wishlist-style"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cavador-wishlist-accessibility')) {
    class CavadorWishlistAccessibility extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        this.root = null;
        this.observing = false;
        if (!document.getElementById('wishlist-hero-shared-list-view') && !window.location.pathname.includes('/a/wishlist-hero/')) return;
        this.observer = new MutationObserver(() => this.observeWishlist());
        this.observeWishlist();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.observing = false; }
      observeWishlist() {
        const root = document.getElementById('wishlist-hero-shared-list-view');
        if (!this.observing || root !== this.root) {
          this.observer.disconnect();
          this.root = root;
          this.observer.observe(root || document.body, { childList: true, subtree: true });
          this.observing = true;
        }
        const label = this.dataset.removeLabel;
        if (!root || !label) return;
        root.querySelectorAll('.wishlist-hero-list-card-footer-delete').forEach(container => {
          const button = container.matches('button, [role="button"]') ? container : container.querySelector('button, [role="button"]');
          if (button && !button.getAttribute('aria-label')?.trim() && !button.getAttribute('aria-labelledby')?.trim() && !button.textContent.trim()) button.setAttribute('aria-label', label);
        });
        const pendingLabel = this.dataset.pricePendingLabel;
        if (!pendingLabel) return;
        root.querySelectorAll('[data-wlh-item-price]').forEach(price => {
          const formatted = (price.getAttribute('data-wlh-item-price') || '').replace(/\s+/g, '');
          const isZero = /^(?:(?:[A-Z]{2,3})?[$€£¥]0(?:[.,]00)?(?:[A-Z]{3})?|0(?:[.,]00)?(?:[$€£¥](?:[A-Z]{2,3})?|[A-Z]{3})|[A-Z]{3}0(?:[.,]00)?)$/i.test(formatted);
          if (isZero && price.textContent !== pendingLabel) price.textContent = pendingLabel;
        });
      }
    }
    customElements.define('cavador-wishlist-accessibility', CavadorWishlistAccessibility);
  }
  } catch(e) { console.error(e); }
})();

})();
